const translations = {
    organizationNameBodyText: "What's the name of this new org?",
    organizationNameFooterText: 'You will become The Admin of this Org. Exciting.',
    organizationNamePlaceholder: 'Org. name'
};

export default translations;
